
  function mapDropdownChange(countryIso, rgba, mapNumber) {
    let baseMapPath = 'https://code.highcharts.com/mapdata/';
    let mapKey = 'countries/' + countryIso + '/' + countryIso + '-all'
    let javascriptPath = baseMapPath + mapKey + '.js'

    function mapReady() {
      let mapGeoJSON = Highcharts.maps[mapKey]
      let data = []

      $.each(mapGeoJSON.features, function (index, feature) {
        data.push({
          key: feature.properties['hc-key'],
          value: index
        })
      })

      $('#country_map_' + mapNumber).highcharts('Map', {
        chart: {
          backgroundColor: 'transparent'
        },
        title: {
          text: null
        },
        mapNavigation: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        colorAxis: {
          minColor: rgba,
          maxColor: rgba,
          labels: {
            enabled: false
          }
        },
        legend: {
          enabled: false
        },
        tooltip: {
          enabled: false
        },
        series: [{
          data: data,
          mapData: mapGeoJSON,
          joinBy: ['hc-key', 'key'],
          borderColor: rgba,
          borderWidth: 0,
          borderShadow: 0,
          name: '',
          states: {
            hover: {
              enabled: false,
              halo: false,
            }
          },
          dataLabels: {
            enabled: false
          }
        }]
      })
    }

    if (mapKey != 'custom/world') {
      if (Highcharts.maps[mapKey]) {
        mapReady()
      } else {
        $.getScript(javascriptPath, mapReady)
      }
    } else {
      switch (mapNumber) {
        case 1:
          $('.country-colors li.red').hide()
          $('#countrymap_notfound_1').show()
          break
        case 2:
          $('.country-colors li.blue').hide()
          $('#countrymap_notfound_2').show()
          break
      }
    }
  }